import { isAccountFacebookPage } from "../../../../entities/accounts/libs/account-platform";
import type { AccountType } from "../../../../shared/types/accounts";
import { createStoredOptInPreference } from "../../../../utils/stored-opt-in";

/** Midnight at the start of 8 Nov 2026 in the browser's local time. */
const FB_STORY_PROMO_ENDS = new Date(2026, 10, 8);

export const FB_STORY_PROMO_ADD_PAGE_URL = "/dashboard/accounts?addFacebook=1";

export function isFbStoryPromoLive(): boolean {
  return Date.now() < FB_STORY_PROMO_ENDS.getTime();
}

const dismissedPreference = createStoredOptInPreference(
  "skedFbStoryPromoDismissed_v1"
);
const scheduledPreference = createStoredOptInPreference(
  "skedFbStoryScheduled_v1"
);

/** Dismissed in this browser, or a Facebook story was already scheduled here. */
export const isFbStoryPromoSuppressed = () =>
  dismissedPreference.isOptedIn() || scheduledPreference.isOptedIn();
export const dismissFbStoryPromo = () => dismissedPreference.optIn();

/**
 * Records the flag when a saved post is a story that includes a Facebook page.
 * Returns whether the post qualified.
 */
export function recordIfFacebookStory(
  post: { isStory?: boolean; accounts?: AccountType[] | null } | undefined
): boolean {
  if (post?.isStory !== true) return false;
  if (!(post.accounts ?? []).some(isAccountFacebookPage)) return false;
  if (!scheduledPreference.isOptedIn()) scheduledPreference.optIn();
  return true;
}
